/**
 * Copyright (c) 2020-2024, hitobito AG. This file is part of
 * hitobito and licensed under the Affero General Public License version 3
 * or later. See the COPYING file at the top-level directory or at
 * https://github.com/hitobito/hitobito.
 */


  // Import all JavaScript files of the wagons (they can provide a
  // app/assets/javascripts/wagon.js.coffee file to be included in the
  // bundle).
  
  
    import '/usr/src/app/hitobito_ssb/app/assets/javascripts/wagon.js.coffee';
  

  // Import all image files of the wagons, so they can be referenced
  // with the `wagon_image_pack_tag` and `wagon_favicon_pack_tag` helpers.
  
  
    require.context('/usr/src/app/hitobito_ssb/app/assets/images', true);
  

